<template lang="pug">
div
    .p-a-sm.white.lt.box-shadow
        .m-t-sm.pull-right(v-show="!onLoading('fetch-stock-check')")
            .dropdown.inline
                button.md-btn.md-raised.m-b-sm.white.m-r-sm.w-xs.dropdown-toggle(
                    data-toggle="dropdown",
                    :disabled="isLoading",
                    aria-expanded="false"
                ) Action
                .dropdown-menu
                    a.dropdown-item(:href="printUrl", target="_blank")
                        i.material-icons.m-r-sm print
                        | Print

        nav(aria-label="breadcrumb")
            ol.breadcrumb.white.m-b-0.p-b-0
                li.breadcrumb-item
                    router-link(to="/") Stock Check
                li.breadcrumb-item.active {{ stockCheck.reference_id }}

    .padding(v-show="!onLoading('fetch-stock-check')")
        stock-check-info
        stock-check-stocks

        .box.dker(v-show="!onLoading('fetch-stock-check')", v-if="!hasFinalized")
            .box-body.text-right
                button.md-btn.md-raised.m-b-sm.w-xs.white.m-r-sm(
                    :disabled="isLoading",
                    @click="cancel",
                ) Cancel

                button.md-btn.md-raised.m-b-sm.green.m-r-sm.w-xs(
                    :disabled="isLoading",
                    @click="saveChanges",
                    v-if="canEdit"
                )
                    v-loading(loader="save-stock-check") Save

                button.md-btn.md-raised.m-b-sm.green.p-r-md.p-l-md.m-r-sm(
                    :disabled="isLoading",
                    @click="markCompleted",
                    v-if="canEdit"
                )
                    v-loading(loader="complete-stock-check") Mark Completed
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import stockCheckEvent from './stock-check-event';
import stockCheckMixin from './stock-check-mixin';
import stockCheckInfo from './stock-check-edit-info.vue';
import stockCheckStocks from './stock-check-edit-stocks.vue';
import { parse } from 'babylon';

export default {
    $_veeValidate: {
        validator: 'new',
    },

    components: { stockCheckInfo, stockCheckStocks },

    mixins: [stockCheckMixin],

    data() {
        return {
            loading: false,
            outletInventories: [],
            addAllStock: false,
        };
    },

    computed: {
        ...mapGetters('stockCheck', ['stockCheck', 'outlet', 'stocks']),

        ...mapGetters('stockInventory', ['stockInventoryList']),

        isLoading() {
            return (
                this.onLoading('fetch-stock-check') ||
                this.onLoading('complete-stock-check') ||
                this.onLoading('save-stock-check')
            );
        },

        printUrl() {
            return Laroute.route('stock_checks.print', {
                id: this.stockCheck.id,
            });
        },
    },

    watch: {
        '$route.params.id': function(id) {
            if (!_.isNil(id)) {
                this.getStockCheck(id);
            }

            this.errors.clear();
            this.clearVarianceError();
        },
    },

    created() {
        this.getStockCheck(this.$route.params.id);
    },

    methods: {
        ...mapActions('stockCheck', [
            'getStockCheck',
            'updateCountedStock',
            'updateStockCheck',
        ]),

        ...mapActions('stockInventory', [
            'getStockInventoryList',
            'setOutletId',
        ]),

        async validateForm() {
            const validate = await this.$validator.validate();

            if (!validate) {
                // focus on error input
                const elem = $('input:text.has-error');
                if (elem.length) {
                    elem[0].focus();
                }
            }

            return validate;
        },

        async saveChanges() {
            const validate = await this.validateForm();
            if (!validate) return;

            if (!this.validateStockVariance()) return;

            try {
                const { data } = await this.updateStockCheck();
                this.swal({ text: 'Stock check has successfully saved' });
                stockCheckEvent.$emit('stock-check-saved');
            } catch (e) {
                this.swalError({ text: e });
            }
        },

        // clear variance error
        clearVarianceError() {
            this.stocks.forEach(s => {
                this.errors.clear(`variance_${s.stock_id}`);
            });
        },

        validateStockVariance() {
            let hasError = false;

            this.clearVarianceError();

            for (var i = 0; i < this.stocks.length; i++) {
                const stock = this.stocks[i];
                const difference = Math.abs(
                    parseFloat(stock.counted_quantity) -
                        parseFloat(stock.expected_quantity),
                ).toFixed(2);

                const varianceQty = stock.variance.reduce(
                    (a, c) => a + parseFloat(c.quantity),
                    0,
                );

                if (Math.abs(varianceQty) != parseFloat(difference)) {
                    let msg = 'Invalid variance quantity';
                    const scope = `variance_${stock.stock_id}`;

                    if (varianceQty == 0) {
                        msg = 'Variance reason is required';
                    }

                    const error = {
                        field: 'variance',
                        msg,
                        scope,
                    };

                    this.errors.add(error);
                    hasError = true;
                }
            }

            return !hasError;
        },

        async markCompleted() {
            if (!this.stocks.length) {
                this.swalWarning({
                    text: 'You must at least add one counted stock to proceed.',
                });

                return;
            }

            const validate = await this.validateForm();
            if (!validate) return;

            if (!this.validateStockVariance()) return;

            try {
                const data = await this.updateStockCheck(true);

                this.swal({
                    text: `Stock check ${data.reference_id} has completed`,
                });
                stockCheckEvent.$emit('stock-check-saved');

                this.$router.push('/');
            } catch (e) {
                this.swalError({ text: e });
            }
        },

        cancel() {
            this.$router.push('/');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/stock_check/stock-check-edit.vue